var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.13 32.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128799;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.79,6.64a6.58,6.58,0,0,0,4.65,11.24h0A6.59,6.59,0,1,0,17.79,6.64Zm9.5,4.65a4.85,4.85,0,0,1-4.84,4.84h0a4.84,4.84,0,1,1,4.85-4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,28H29.91a.86.86,0,0,0,.87-.84c0-.24.15-5.8-3.34-9a.89.89,0,0,0-1.12-.05s-3.91,2.94-7.5,0a.86.86,0,0,0-1.12,0,12.37,12.37,0,0,0-3.6,9,.85.85,0,0,0,.26.62A.84.84,0,0,0,15,28Zm3.39-8a7.77,7.77,0,0,0,8.36,0A11,11,0,0,1,29,26.21H15.89A11,11,0,0,1,18.37,19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.7,15v2.33H3.94V15Zm-3.66,6H7.59V11.29H10Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add_user.92bacf80609fab405353f57768d761c2.svg";
export { ForwardRef as ReactComponent };